"use strict";

require("../../style/default.less");
require("./index.less");
require("../../grid/style");
require("../../tooltip/style");